import lesson0 from './pre-assessment';
import lesson1 from './lesson_1';
import lesson2 from './lesson_2';
import lesson3 from './lesson_3';
import lesson4 from './lesson_4';
import lesson5 from './lesson_5';
import lesson6 from './lesson_6';
import lesson7 from './lesson_7';
import lesson8 from './lesson_8';
import lesson9 from './lesson_9';
import lesson10 from './lesson_10';
import lesson11 from './lesson_11';
import lesson12 from './lesson_12';
import lesson13 from './lesson_13';
import lesson14 from './lesson_14';
import lesson15 from './lesson_15';
import lesson16 from './lesson_16';
import lesson17 from './lesson_17';
import lesson18 from './lesson_18';
import lesson19 from './lesson_19';
import lesson20 from './lesson_20';

//Lessons array
export const lessons = {
  0: lesson0,
  1: lesson1,
  2: lesson2,
  3: lesson3,
  4: lesson4,
  5: lesson5,
  6: lesson6,
  7: lesson7,
  8: lesson8,
  9: lesson9,
  10: lesson10,
  11: lesson11,
  12: lesson12,
  13: lesson13,
  14: lesson14,
  15: lesson15,
  16: lesson16,
  17: lesson17,
  18: lesson18,
  19: lesson19,
  20: lesson20
}

//Lessons title;
export const lessonsTitle = [
  'Pre-Assessment',
  'Lesson 1 (Intro and Board Basics)',
  'Lesson 2 (The Board and Pieces)',
  'Lesson 3 (The Pawn)',
  'Lesson 4 (The Knight)',
  'Lesson 5 (The Bishop)',
  'Lesson 6 (The Rook)',
  'Lesson 7 (The Queen)',
  'Lesson 8 (The King)',
  'Lesson 9 (Checkmate and Stalemate)',
  'Lesson 10 (Castling)',
  'Lesson 11 (Notation)',
  'Lesson 12 (Ladder Mate)',
  'Lesson 13 (Knight\'s Tour)',
  'Lesson 14 (En Passant)',
  'Lesson 15 (Crowded Queendom)',
  'Lesson 16 (Patterns)',
  'Lesson 17 (Tactics)',
  'Lesson 18 (The Square)',
  'Lesson 19 (Planning)',
  'Lesson 20 (Make a Mate)'
]


// WEBPACK FOOTER //
// ./src/lessons/index.js